import * as React from "react";
import { OrderPickupState } from "../partsStatus.utils";

/**
 * Blue -> teal -> green tracks progress: none collected, some, all. Orange is reserved
 * for the action buttons and amber for the reported-problem warning.
 *
 * Inline rather than Tailwind classes: MUI v4 injects `.MuiChip-root` after the
 * Tailwind sheet, and at equal specificity the later rule wins — a `bg-*` class on a
 * Chip silently renders MUI's default grey.
 */
export const stateColors: Record<OrderPickupState, React.CSSProperties> = {
  AWAITING: { backgroundColor: "#2563eb", color: "#ffffff" },
  PARTIAL: { backgroundColor: "#0d9488", color: "#ffffff" },
  COLLECTED: { backgroundColor: "#15803d", color: "#ffffff" },
  CANCELED: { backgroundColor: "#7f1d1d", color: "#fecaca" },
  // Darker than the card, so a neutral state reads as recessed rather than raised.
  EMPTY: { backgroundColor: "#16202e", color: "#94a3b8" },
};

export const chipStyle: React.CSSProperties = { height: 22, fontSize: 12, fontWeight: 600 };
